<template>
  <div class="product-information-card" :class="[`theme-${theme}`]">
    <div class="product-information-card__type">
      <i :class="icon"></i>
    </div>
    <div class="top">
      <div class="image-wrap">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
          <filter id="blur">
              <feGaussianBlur stdDeviation="10" />
          </filter>
        </svg>
        <div class="background-mask">
          <div class="background-mask__shade" v-if="haveImage"></div>
          <div class="full-picture blur" :style="backgroundMaskImage()"></div>
        </div>
        <div class="image-circle">
          <div class="image" :style="picture()"></div>
          <i :class="icon"></i>
        </div>
      </div>
      <div v-show="!isReady">
        <span class="text-dummy-loader"></span>
        <span class="text-dummy-loader is-slim-wide"></span>
      </div>
      <div v-show="isReady">
        <p class="name" v-if="productDetails.name">
          <span>{{ productDetails.name }}</span>
        </p>
        <p class="description" v-if="productDetails.description">
          <span>{{ productDetails.description }}</span>
        </p>
      </div>
    </div>
    <p v-if="dividerTitle" class="ui-element horizontal-divider">
      <span>{{ dividerTitle }}</span>
    </p>
    <hr v-else>
  </div>
</template>

<script>
import { get, isEmpty } from 'lodash';

export default {
  name: 'product-information-card',
  props: {
    productDetails: {
      type: Object,
      required: true,
      default: null,
    },
    dividerTitle: {
      type: String,
      required: false,
      default: null,
    },
    fetching: {
      type: Boolean,
      required: false,
      default: true,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: 'grey',
    },
  },
  methods: {
    picture() {
      const imagesRoot = process.env.IMAGES_ROOT;
      const path = get(this.productDetails, 'CoverImage.path', false);
      const filename = get(this.productDetails, 'CoverImage.thumbnails.large.filename', false);
      const fullPath = (imagesRoot && path && filename) ? imagesRoot + path + filename : '';
      return `backgroundImage: url(${fullPath})`;
    },
    backgroundMaskImage() {
      const imagesRoot = process.env.IMAGES_ROOT;
      let path = false;

      let filename = get(this.productDetails, 'Participant.ProfilePicture.thumbnails.large.filename', false);

      if (filename) {
        path = get(this.productDetails, 'Participant.ProfilePicture.path', false);
      } else {
        path = get(this.productDetails, 'CoverImage.path', false);
        filename = get(this.productDetails, 'CoverImage.thumbnails.large.filename', false);
      }

      const fullPath = (imagesRoot && path && filename) ? imagesRoot + path + filename : '';
      return fullPath ? `backgroundImage: url(${fullPath})` : '';
    },
  },
  computed: {
    isReady() {
      return !this.fetching && !isEmpty(this.productDetails);
    },
    haveImage() {
      const participant = get(this.productDetails, 'Participant.ProfilePicture.thumbnails.large.filename', false);
      const cover = get(this.productDetails, 'CoverImage.thumbnails.large.filename', false);
      return participant || cover;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/theme/colors";
@import "~styles/theme/content-colors";
@import '~styles/mixins/gradients';

.product-information-card {
  width: 100%;
  position: relative;

  .product-information-card__type {
    position: absolute;
    top: 1.25em;
    right: 1.5em;
    z-index: 2;
    i {
      color: #fff;
      font-size: 1.25rem;
    }
  }

  .top {
    text-align: center;

    .image-wrap {
      padding: 1em 0 0;
      position: relative;

      svg {
        display: none;
      }

      .blur {
        transition: 1s;
        top: 0; left: 0;
        position: absolute;
        filter: url(#blur);
        filter: blur(10px);
        filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='10');
      }

      .full-picture {
        top: -5%;
        left: -5%;
        width: 110%;
        height: 110%;
        position: absolute;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }

      .kcal-circle {
        z-index: 2;
        position: absolute;
        bottom: 1.15em;
        left: calc(50% + 31px);
        width: 20px;
        height: 20px;
        background-color: #fff;
        border-radius: 50%;
        // padding: 4px;
      }

      .image-circle {
        z-index: 1;
        width: 10em;
        height: 10em;
        margin-top: 4em;
        overflow: hidden;
        position: relative;
        border-radius: 50%;
        display: inline-block;
        border: 0.5em solid #fff;
        transition: background 0.5s ease;
         .image {
          width: 100%;
          height: 100%;
          top: 0; left: 0;
          position: absolute;
          background-size: auto 100%;
          background-repeat: no-repeat;
          background-position: center center;
        }
        i {
          font-size: 7rem;
          line-height: 8.5rem;
          color: #fff;
        }
      }

      .background-mask {
        z-index: 0;
        height: 12em;
        margin: 0.5em;
        top: 0; left: 0;
        overflow: hidden;
        position: absolute;
        width: calc(100% - 1em);
        border-top-left-radius: 0.25em;
        border-top-right-radius: 0.25em;
        transition: background 0.5s ease;
        clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);
        -webkit-clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);

        .background-mask__shade {
          top: 0;
          left: 0;
          right: 0;
          z-index: 2;
          height: 3.5em;
          position: absolute;
          background-color: rgba(0, 0, 0, 0.25);
        }
      }
    }

  }

  .text-dummy-loader {
    width: 60%;
    height: 1em;
    display: inline-block;
    background-color: rgba(0,0,0,0.35);
    &.is-slim-wide {
      width: 70%;
      height: 0.75em;
      background-color: rgba(0,0,0,0.15);
    }
  }

  .horizontal-divider, hr {
    margin: 0.75em 0.75em;
    span {
      color: gray;
      font-weight: 600;
      font-size: 0.8rem;
      text-transform: uppercase;
    }
  }

  .name, .description {
    width: 90%;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    @supports (-moz-appearance:none) {
      max-width: 280px;
    }
  }

  .name {
    font-weight: 800;
    font-size: 1.10em;
  }
  .description {
    color: $gray-light;
  }

  aside {
    margin: 0 1em;
  }

  &.theme-grey {
    .background-mask {
      @include gradient-vertical($gray-light, $gray);
    }
    .top {
      .image-circle {
        background-color: $gray-light;
        i {
          font-size: 5rem;
        }
      }
    }
  }

  &.theme-diet {
    .background-mask {
      background-size: 150% auto;
      background-color: $color-diet;
      background-position: center center;
      background-image: url(~assets/images/svg-shapes/shape-01-transparent-black-20.svg);
    }
    .top {
      .image-circle {
        background-color: $color-diet-light;
        i {
          font-size: 5rem;
        }
      }
    }
  }

  &.theme-meal {
    .background-mask {
      @include gradient-vertical($color-meal-light, $color-meal);
      background-size: 150% auto;
      background-position: center center;
      background-image: url(~assets/images/svg-shapes/shape-01-transparent-black-10.svg);
    }
    .top {
      .image-circle {
        background-color: $color-meal-light;
        i {
          font-size: 5rem;
        }
      }
    }
  }

  &.theme-dish {
    .background-mask {
      @include gradient-vertical($color-dish-lighter, $color-dish);
      background-size: 150% auto;
      background-position: center center;
      background-image: url(~assets/images/svg-shapes/shape-01-transparent-black-10.svg);
    }
    .top {
      .image-circle {
        background-color: $color-dish-light;
        i {
          font-size: 5rem;
        }
      }
    }
  }

  &.theme-drink {
    .background-mask {
      @include gradient-vertical($color-drink-light, $color-drink);
      background-size: 150% auto;
      background-position: center center;
      background-image: url(~assets/images/svg-shapes/shape-01-transparent-black-10.svg);
    }
    .top {
      .image-circle {
        background-color: $color-drink-light;
        i {
          font-size: 5rem;
        }
      }
    }
  }

  &.theme-food-product {
    .background-mask {
      @include gradient-vertical($color-food-product, $color-food-product-dark);
      background-size: 150% auto;
      background-position: center center;
      background-image: url(~assets/images/svg-shapes/shape-01-transparent-black-10.svg);
    }
    .top {
      .image-circle {
        background-color: $color-food-product;
        i {
          font-size: 5rem;
          // color: $color-food-product-darker;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/ui/card/product-information-card.vue